import { render, staticRenderFns } from "./CreatorBubbles.vue?vue&type=template&id=a49ea51c&"
import script from "./CreatorBubbles.vue?vue&type=script&lang=js&"
export * from "./CreatorBubbles.vue?vue&type=script&lang=js&"
import style0 from "./CreatorBubbles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports